import { isArray } from "@thi.ng/checks/is-array";
import { isTypedArray } from "@thi.ng/checks/is-typedarray";
import { toPath } from "./path.js";
const defSetterUnsafe = (path) => defSetter(path);
function defSetter(path) {
  const ks = toPath(path);
  const [a, b, c, d] = ks;
  switch (ks.length) {
    case 0:
      return (_, v) => v;
    case 1:
      return (s, v) => (s = copy(s), s[a] = v, s);
    case 2:
      return (s, v) => {
        let x;
        s = copy(s);
        s[a] = x = copy(s[a]);
        x[b] = v;
        return s;
      };
    case 3:
      return (s, v) => {
        let x, y;
        s = copy(s);
        s[a] = x = copy(s[a]);
        x[b] = y = copy(x[b]);
        y[c] = v;
        return s;
      };
    case 4:
      return (s, v) => {
        let x, y, z;
        s = copy(s);
        s[a] = x = copy(s[a]);
        x[b] = y = copy(x[b]);
        y[c] = z = copy(y[c]);
        z[d] = v;
        return s;
      };
    default:
      let f;
      for (let i = ks.length; i-- > 0; ) {
        f = __compSetter(ks[i], f);
      }
      return f;
  }
}
const copy = (x) => isArray(x) || isTypedArray(x) ? x.slice() : { ...x };
const __compSetter = (k, f) => (s, v) => {
  s = copy(s);
  s[k] = f ? f(s[k], v) : v;
  return s;
};
export {
  copy,
  defSetter,
  defSetterUnsafe
};
